/* Emozioni — motion system v2 (replica fedele del motion titoli Almare LIVE).
   Titoli h1/h2/display: SplitText WORDS — ogni parola: yPercent 110 + blur(12px)->0 + opacity 0->1,
   curva CustomEase almaOut (0.18,0.8,0.28,1), stagger. NIENTE maschera per riga (parole libere).
   Plugin allineati ad Almare: GSAP 3.15 + SplitText + CustomEase + ScrollTrigger (jsDelivr).
   Riusabile su tutto il sito:
     [data-reveal]       -> titolo: words-rise + blur (above-fold al load, sotto via ScrollTrigger once)
     [data-reveal-fade]  -> label / CTA / sottotitoli: fade-up y18 ritardato
   Rispetta prefers-reduced-motion. */
(function () {
  if (!window.gsap) return;
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
  if (window.SplitText) gsap.registerPlugin(SplitText);
  if (window.CustomEase) {
    CustomEase.create('almaOut', '0.18,0.8,0.28,1');
    CustomEase.create('almaDrift', '0.25,0.46,0.3,0.95');
  }
  var E = window.CustomEase ? 'almaOut' : 'power3.out';
  var BELOW = function (el) { return el.getBoundingClientRect().top > innerHeight - 8; };

  function words(el) {
    if (el.__words) return el.__words;
    var w;
    if (window.SplitText) {
      var s = new SplitText(el, { type: 'words', wordsClass: 'emo-word' });
      w = s.words;
    } else {
      el.setAttribute('aria-label', el.textContent);
      var parts = el.textContent.split(/(\s+)/);
      el.innerHTML = '';
      w = [];
      parts.forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { el.appendChild(document.createTextNode(p)); return; }
        var sp = document.createElement('span');
        sp.style.display = 'inline-block';
        sp.textContent = p;
        el.appendChild(sp);
        w.push(sp);
      });
    }
    w.forEach(function (x) { x.style.willChange = 'transform,filter'; });
    el.__words = w;
    return w;
  }

  function revealTitle(el, delay) {
    var w = words(el);
    gsap.set(el, { opacity: 1 });
    gsap.from(w, {
      yPercent: 110, opacity: 0, filter: 'blur(12px)',
      duration: 0.8, ease: E, stagger: { amount: 0.38 }, delay: delay || 0,
      onComplete: function () { gsap.set(w, { clearProps: 'filter,willChange' }); }
    });
  }

  function revealFade(el, delay) {
    gsap.from(el, { opacity: 0, y: 18, duration: 0.6, ease: 'power2.out', delay: delay || 0 });
  }

  function init() {
    var titles = [].slice.call(document.querySelectorAll('[data-reveal]'));
    var fades = [].slice.call(document.querySelectorAll('[data-reveal-fade]'));
    if (rm) { titles.concat(fades).forEach(function (el) { el.style.opacity = 1; }); return; }
    titles.forEach(function (el) {
      gsap.set(el, { opacity: 0 });
      var d = parseFloat(el.getAttribute('data-reveal-delay')) || 0;
      if (window.ScrollTrigger && BELOW(el)) {
        ScrollTrigger.create({ trigger: el, start: 'top bottom-=140', once: true, onEnter: function () { revealTitle(el, 0); } });
      } else { revealTitle(el, d); }
    });
    fades.forEach(function (el) {
      var d = parseFloat(el.getAttribute('data-reveal-delay'));
      if (isNaN(d)) d = 0.6;
      if (window.ScrollTrigger && BELOW(el)) {
        ScrollTrigger.create({ trigger: el, start: 'top bottom-=120', once: true, onEnter: function () { revealFade(el, 0); } });
      } else { revealFade(el, d); }
    });
    // FIRMA — draw del tracciato Mr De Haviland: ogni lettera si scrive in sequenza (sx->dx), poi il fill appare
    [].slice.call(document.querySelectorAll('[data-sig-draw]')).forEach(function (sig) {
      var paths = sig.querySelectorAll('.sig-p');
      if (!paths.length || rm) return;
      paths.forEach(function (p) {
        var len = p.getTotalLength();
        p.style.fillOpacity = '0';
        p.style.stroke = '#f1ede3';
        p.style.strokeWidth = '30';
        p.style.strokeLinecap = 'round';
        p.style.strokeLinejoin = 'round';
        p.style.strokeDasharray = len;
        p.style.strokeDashoffset = len;
      });
      var below = window.ScrollTrigger && BELOW(sig);
      var run = function () {
        var tl = gsap.timeline({ delay: below ? 0 : 1.0 });
        tl.to(paths, { strokeDashoffset: 0, duration: 0.42, ease: 'power1.out', stagger: 0.07 });
        tl.to(paths, { fillOpacity: 1, duration: 0.4, stagger: 0.07 }, 0.22);
        tl.to(paths, { strokeWidth: 0, duration: 0.5 }, '-=0.2');
      };
      if (below) ScrollTrigger.create({ trigger: sig, start: 'top bottom-=140', once: true, onEnter: run });
      else run();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
